module.exports = __webpack_public_path__ + "img/尉宏广.54688647.jpg";